import Benefits from '../../../screens/animations/benefits';
import CircleTakeover from '../../../screens/animations/circleTakeover';
import GoalRecap from '../../../screens/animations/goalRecap';
import PhonePermission from '../../../screens/animations/phonePermission';
import Pillars from '../../../screens/animations/pillars';
import Pillars2 from '../../../screens/animations/pillars2';
import PillarsIntro from '../../../screens/animations/pillarsIntro';
import PlanJourney from '../../../screens/animations/planJourney';
import PlanJourney2 from '../../../screens/animations/planJourney2';
import PlanSection from '../../../screens/animations/planSection';
import PlanSteps from '../../../screens/animations/planSteps';
import QuoteScreen from '../../../screens/animations/quote';
import Rings from '../../../screens/animations/rings';
import SectionIntro from '../../../screens/animations/sectionIntro';
import InputsScreen from '../../../screens/inputs';
import PhoneScreen from '../../../screens/phone';
import PhoneScreen2 from '../../../screens/phone2';

export const PLAN_SCREENS = [
    {
        key: 'plan section',
        trackingName: 'plan section',
        screenName: 'plan section',
        component: <PlanSection />
    },
    {
        key: 'plan section intro',
        screenName: 'plan section intro',
        component: (
            <SectionIntro
                sectionKey={'plan'}
                subtitle={'Based on your responses, we think you\'re a great fit for Sunnyside. Now it\'s time to see your custom plan!'}
            />
        )
    },
    {
        key: 'plan steps',
        trackingName: 'plan steps',
        screenName: 'plan steps',
        component: (
            <PlanSteps
                position={1}
            />
        )
    },
    {
        key: 'goal recap',
        screenName: 'goal recap',
        component: (
            <GoalRecap
                position={2}
            />
        )
    },
    {
        key: 'pillars intro',
        trackingName: 'pillars intro',
        screenName: 'pillars intro',
        component: (
            <PillarsIntro
                position={6}
            />
        )
    },
    {
        key: 'pillars',
        screenName: 'pillars',
        component: (
            <Pillars
                position={7}
            />
        )
    },
    {
        key: 'phone permission',
        trackingName: 'phone permission',
        screenName: 'phone permission',
        component: (
            <PhonePermission
                position={15}
            />
        )
    },
    {
        key: 'phone entry',
        screenName: 'phone entry',
        component: (
            <PhoneScreen
                position={16}
            />
        )
    },
    {
        key: 'plan intro',
        trackingName: 'plan intro',
        screenName: 'plan intro',
        component: (
            <CircleTakeover
                position={18}
                sectionKey={'plan'}
                title={'Next, we\'ll review a high-level timeline and the impact you can expect as we make progress together.'}
                body={'Based on others with similar starting points, here\'s the progress you can expect with Sunnyside.'}
            />
        )
    },
    {
        key: 'plan journey',
        screenName: 'plan journey',
        component: (
            <PlanJourney
                position={19}
            />
        )
    },
    {
        key: 'plan summary',
        screenName: 'plan summary',
        component: (
            <Rings
                position={27}
            />
        )
    },
    {
        key: 'benefits',
        trackingName: 'benefits',
        screenName: 'benefits',
        component: (
            <Benefits
                position={30}
            />
        )
    },
    {
        key: 'plan quote',
        trackingName: 'plan quote',
        screenName: 'plan quote',
        component: (
            <QuoteScreen
                sectionKey={'plan'}
                title={'You\'ve made it!'}
                subtitle={'One last step before we kick off the journey to healthier drinking habits!'}
                quote={'Joining Sunnyside is one of the best things I\'ve ever done for myself. You\'ve helped me completely change my relationship with drinking, and with myself.'}
                user={'Sophie'}
                duration={1}
            />
        )
    }
];

export const PLAN_SCREENS_V2 = [
    {
        key: 'plan section',
        trackingName: 'plan section',
        screenName: 'plan section',
        component: <PlanSection />
    },
    {
        key: 'plan section intro',
        screenName: 'plan section intro',
        component: (
            <SectionIntro
                sectionKey={'plan'}
                subtitle={'Based on your responses, we think you\'re a great fit for Sunnyside. Now it\'s time to see your custom plan!'}
            />
        )
    },
    {
        key: 'phone entry',
        screenName: 'phone entry',
        component: (
            <PhoneScreen2
                position={1}
            />
        )
    },
    {
        key: 'plan steps',
        trackingName: 'plan steps',
        screenName: 'plan steps',
        component: (
            <PlanSteps
                position={3}
                canSkip
            />
        )
    },
    {
        key: 'goal recap',
        screenName: 'goal recap',
        component: (
            <GoalRecap
                position={4}
            />
        )
    },
    {
        key: 'pillars intro',
        trackingName: 'pillars intro',
        screenName: 'pillars intro',
        component: (
            <PillarsIntro
                position={8}
            />
        )
    },
    {
        key: 'pillars',
        screenName: 'pillars',
        component: (
            <Pillars2
                position={9}
            />
        )
    },
    {
        key: 'plan intro',
        trackingName: 'plan intro',
        screenName: 'plan intro',
        component: (
            <CircleTakeover
                position={13}
                sectionKey={'plan'}
                title={'Next, we\'ll review a high-level timeline and the impact you can expect as we make progress together.'}
                body={'Based on others with similar starting points, here\'s the progress you can expect with Sunnyside.'}
            />
        )
    },
    {
        key: 'plan journey',
        screenName: 'plan journey',
        component: (
            <PlanJourney2
                position={14}
            />
        )
    },
    {
        key: 'plan summary',
        screenName: 'plan summary',
        component: (
            <Rings
                position={17}
            />
        )
    },
    {
        key: 'benefits',
        trackingName: 'benefits',
        screenName: 'benefits',
        component: (
            <Benefits
                position={20}
            />
        )
    },
    {
        key: 'plan quote',
        trackingName: 'plan quote',
        screenName: 'plan quote',
        component: (
            <QuoteScreen
                sectionKey={'plan'}
                title={'You\'ve made it!'}
                subtitle={'One last step before we kick off the journey to healthier drinking habits!'}
                quote={'Joining Sunnyside is one of the best things I\'ve ever done for myself. You\'ve helped me completely change my relationship with drinking, and with myself.'}
                user={'Sophie'}
                duration={1}
            />
        )
    }
];

export const PLAN_SCREENS_V3 = [
    {
        key: 'plan section',
        trackingName: 'plan section',
        screenName: 'plan section',
        component: <PlanSection />
    },
    {
        key: 'plan section intro',
        screenName: 'plan section intro',
        component: (
            <SectionIntro
                sectionKey={'plan'}
                subtitle={'Based on your responses, we think you\'re a great fit for Sunnyside. Now it\'s time to see your custom plan!'}
            />
        )
    },
    {
        key: 'inputs screen',
        screenName: 'inputs screen',
        component: (
            <InputsScreen
                position={1}
                sectionKey={'plan'}
                backJump={2}
            />
        )
    },
    {
        key: 'plan steps',
        trackingName: 'plan steps',
        screenName: 'plan steps',
        component: (
            <PlanSteps
                position={5}
                backJump={1}
                canSkip
            />
        )
    },
    {
        key: 'goal recap',
        screenName: 'goal recap',
        component: (
            <GoalRecap
                position={6}
            />
        )
    },
    {
        key: 'pillars intro',
        trackingName: 'pillars intro',
        screenName: 'pillars intro',
        component: (
            <PillarsIntro
                position={10}
            />
        )
    },
    {
        key: 'pillars',
        screenName: 'pillars',
        component: (
            <Pillars2
                position={11}
            />
        )
    },
    {
        key: 'plan intro',
        trackingName: 'plan intro',
        screenName: 'plan intro',
        component: (
            <CircleTakeover
                position={15}
                sectionKey={'plan'}
                title={'Next, we\'ll review a high-level timeline and the impact you can expect as we make progress together.'}
                body={'Based on others with similar starting points, here\'s the progress you can expect with Sunnyside.'}
            />
        )
    },
    {
        key: 'plan journey',
        screenName: 'plan journey',
        component: (
            <PlanJourney2
                position={16}
            />
        )
    },
    {
        key: 'plan summary',
        screenName: 'plan summary',
        component: (
            <Rings
                position={19}
            />
        )
    },
    {
        key: 'benefits',
        trackingName: 'benefits',
        screenName: 'benefits',
        component: (
            <Benefits
                position={22}
            />
        )
    },
    {
        key: 'plan quote',
        trackingName: 'plan quote',
        screenName: 'plan quote',
        component: (
            <QuoteScreen
                sectionKey={'plan'}
                title={'You\'ve made it!'}
                subtitle={'One last step before we kick off the journey to healthier drinking habits!'}
                quote={'Joining Sunnyside is one of the best things I\'ve ever done for myself. You\'ve helped me completely change my relationship with drinking, and with myself.'}
                user={'Sophie'}
                duration={1}
            />
        )
    }
];
